import { mechanicApiPost } from 'widgets/mechanic/api/mechanicApiPost';
import { toast } from 'react-toastify';

const mechanicCreateApi = mechanicApiPost.injectEndpoints({
  endpoints: (builder) => ({
    createMechanic: builder.mutation({
      query: ({ app_type, form }) => ({
        url: `/promo-b2b/${app_type}/promo-b2b/admin/objectives/`,
        method: 'POST',
        body: form,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при создании механики';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали новую механику', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'CreateMechanic', id: arg.id },
          { type: 'CreateMechanic', id: 'ALL' },
        ];
      },
    }),
    updateMechanic: builder.mutation({
      query: ({ app_type, id, form }) => ({
        url: `/promo-b2b/${app_type}/promo-b2b/admin/objectives/${id}/`,
        method: 'PATCH',
        body: form,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = 'Произошла ошибка при обновлении механики';
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили механику', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'UpdateMechanic', id: arg.id },
          { type: 'UpdateMechanic', id: 'ALL' },
        ];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useCreateMechanicMutation } = mechanicCreateApi;
